import { useContext, createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  clearUserDetailsFromDB,
  getUserDetailsFromDB,
  storeUserDetails,
} from "../utils/databaseConfig";
import { axiosInstance } from "../service/axiosInstance";
import serviceEndpoints from "../services/serviceEndpoints";

const AuthContext = createContext();
let externalFetchUserDetails;

const AuthProvider = ({ children }) => {
  const [userDetail, setUserDetail] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const fetchUserDetails = async () => {
    const user = await getUserDetailsFromDB();
    setUserDetail(user);
  };

  useEffect(() => {
    fetchUserDetails();
    externalFetchUserDetails = fetchUserDetails;
  }, []);

  const loginFn = async (data) => {
    setUserDetail(data);
    await storeUserDetails(data);
    navigate("/handle-meetings");
  };

  const logOut = async () => {
    try {
      await axiosInstance.post(serviceEndpoints.logoutEndpoints, {
        refreshToken: userDetail?.data.refreshToken,
      });

      setUserDetail(null);
      clearUserDetailsFromDB();

      navigate("/", { replace: true });
    } catch (error) {
      console.log("error");
    }
  };

  return (
    <AuthContext.Provider
      value={{ userDetail, logOut, loginFn, isLoading, setIsLoading }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const triggerFetchUser = () => {
  if (externalFetchUserDetails) {
    externalFetchUserDetails();
  }
};

export const useAuth = () => {
  return useContext(AuthContext);
};
